module.exports = __webpack_public_path__ + "login-bg.c6bac52507276188b9be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background/login-bg.png
// module id = 491
// module chunks = 5